import { generateHash, generateMinifiedQuery } from "../../client/Graphql/hash";

export const pageQuery = `query ($site: String!, $path: String, $pageId: String, $device: Device!, $includeContent: Boolean, $moduleLimit: Int, $moduleOffset: Int, $languageCode: String, $countryCode: String, $userState: String, $modules: [String!], $offset: Int, $platform:EntitlementDevice, $next: String,$isVertical: Boolean,$zipcode:String ) {
  page(
    site: $site
    path: $path
    pageId: $pageId
    device: $device
    includeContent: $includeContent
    moduleLimit: $moduleLimit
    moduleOffset: $moduleOffset
    languageCode: $languageCode
    countryCode: $countryCode
    userState: $userState
    modules: $modules
    offset: $offset
    platform :$platform
    next: $next
    isVertical: $isVertical
    zipcode: $zipcode
  ) {
    id
    moduleCount
    moduleIds
    title
    pageType
    ogDetails {
      thumbnailUrl
      title
      description
    }
    metadataMap {
      title
      keywords
      description
      h1Title
      h2Title
      contentType
      contentUrl
      image
      isLiveStream
      duration
      uploadDate
      thumbnailUrl {
        r16x9
      }
    }
    modules {
      id
      moduleType
      ... on MastheadModule {
        setting {
          hideDate
        }
        metadataMap
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      ... on LanguageSettingModule {
        id 
        title
        metadataMap
        moduleType
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      
      ... on ChatModule {
        setting {
          hideDate
        }
        metadataMap
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      
      ... on TextModule {
        rawText
        metadataMap
        layout {
          ...Layout
        }
      }
      ... on SearchModule {
        metadataMap
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      ...on HistoryModule {
        id
        title
        metadataMap
         layout {
          ...Layout
          ...PartialFonts
        }
      }
      ...on CheckoutModule{
        id
        metadataMap
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      ...on PlanBannerModule{
        id
        title
        moduleType
        metadataMap
        layout{
          ...Layout
          ...PartialFonts
        }
      }
      ...on QueueModule {
        id
        title
        metadataMap
         layout {
          ...Layout
          ...PartialFonts
        }
      }
      ...on ShowDetailModule {
        id
        metadataMap
        plans {
          ...VLMonetizationPlan
        }
        contentData {
          id
          gist {
            id
            title
            description
            contentType
            permalink
            primaryCategory{
              id
              title
            }
            scheduleStartDate
            scheduleEndDate
            imageGist {
              r32x9
              r16x9
              r4x3
              r3x4
              r1x1
              r9x16
            }
          }
          ... on Series {
            id
            title
            parentalRating
            publishDate
            network
            categories {
              id
              title
            }
            monetizationModels {
              id 
              type
            }
            monetizationBadgeIdentifier
            plans {
              planIds
              type
              planGroupIds
            }
            creditBlocks{
              title
              credits{
                title
              }
            }
            seasons {
              title
              episodes {
                id
                title
                publishDate
                episodeDisplayAttribute
               runtime
               categories {
                id
                title
              }
                gist {
                  id
                  title
                  description
                  contentType
                  permalink
                  scheduleStartDate
                  scheduleEndDate
                  primaryCategory{
                    id
                    title
                  }
                  imageGist {
                    r32x9
                    r16x9
                    r4x3
                    r3x4
                    r1x1
                    r9x16
                  }
                }
                plans {
                  type
                  planIds
                  planGroupIds
                }
                monetizationModels{
                  type
                  id
                }
                badges{
                  id
                  title
                  alignment
                  type
                  visible
                  images{
                    r4x3
                    r3x4
                    r1x1
                    r32x9
                    r16x9
                    r9x16
                  }
                  style{
                    backgroundColor
                    gradientColor
                    textColor
                    borderColor
                    borderWidth
                  }
                }
              }
            }
            trailers{
              id
            }
            badges{
              id
              title
              alignment
              type
              visible
              images{
                r4x3
                r3x4
                r1x1
                r32x9
                r16x9
                r9x16
              }
              style{
                backgroundColor
                gradientColor
                textColor
                borderColor
                borderWidth
              }
            }
          }
        }
        plans {
          ...VLMonetizationPlan
        }
         layout {
          ...Layout
          ...PartialFonts
        }
      }
      ...on CheckoutModule{
        id
        metadataMap
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      ... on GameDetailModule {
        title
        metadataMap
        contentData {
          id
          gist {
            id
            title
            contentType
            description
            permalink
            imageGist {
              r32x9
              r16x9
              r4x3
              r3x4
              r1x1
              r9x16
            }
          }
          ... on Game {
            id
            publishDate
            displayAttribute
            ticketUrl
            monetizationBadgeIdentifier
            monetizationModels{
              type
            }
            plans {
              type
              planIds
            }
            gist {
              id
              title
              contentType
              description
              permalink
              imageGist {
                r32x9
                r16x9
                r4x3
                r3x4
                r1x1
                r9x16
              }
            }
            preview {
              id
              gist {
                id
                title
                  imageGist {
                    r32x9
                    r16x9
                    r4x3
                    r3x4
                    r1x1
                    r9x16
                  }
              }
              monetizationModels{
                id,
                type
              }
              plans{
                type,
                planIds,
                planGroupIds
              }
            }
            currentState
            states{
              live{
                startDateTime
              }
            }
            schedules {
              startDate
              endDate
              venue{
               id
               title
               gist {
                id
                site
                permalink
                title
                description
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
                primaryCategory {
                  id
                  title
                }
                contentType
                languageCode
                timezone
                scheduleStartDate
                scheduleEndDate
              }  
            }
          }
            league {
              id
              title
            }
            score{
              status
              type
              number
              homePoint
              awayPoint
              clock
            }
            homeTeam {
              owner
              id
              shortName
              currentSeason
              records {
                PST {
                  win
                  loss
                  points
                  overtimeLosses
                }
                REG{
                  win
                  loss
                  points
                  overtimeLosses
                }
                PRE{
                  win
                  loss
                  points
                  overtimeLosses
                }
                PIT{
                  win
                  loss
                  points
                  overtimeLosses
                }
              }
              gist {
                id
                title
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
              }
            }
            related {
              id
              title
              runtime
              metadata{
                name
                value
              }
              monetizationModels{
                id
                type
              }
              gist {
                id
                title
                description
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
                permalink
              }
            }
            awayTeam {
              owner
              id
              shortName
              currentSeason
              records {
                PST {
                  win
                  loss
                  points
                  overtimeLosses
                }
                REG{
                  win
                  loss
                  points
                  overtimeLosses
                }
                PRE{
                  win
                  loss
                  points
                  overtimeLosses
                }
                PIT{
                  win
                  loss
                  points
                  overtimeLosses
                }
              }
              gist {
                id
                title
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
              }
            }
            golfStats {
              currentRound
              currentStatusIdentifier
              eventStatus
              roundStates {
                round
                statusIdentifier
              }
            }
            persons{
              id
              title
              firstName
              lastName
              gist{
                id
                imageGist{
                  r1x1
                }
              }
              team{
                gist{
                  imageGist{
                    r1x1
                  }
                }
              }
            }
            championsData{
              id
            }
            livestreams {
              id
              title
              gist {
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
                permalink
              }
              monetizationModels{
                id,
                type
              }
              plans{
                type,
                planIds,
                planGroupIds
              }
            }
            metadata {
              name
              value
            }
            sportsRadar{
              id
              seasonId
              widgetType
            }
            highlights {
              id
              runtime
              metadata{
                name
                value
              }
              monetizationModels{
                id
                type
              }
              publishDate
              gist {
                id
                title
                description
                contentType
                permalink
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
              }
            }
          }
        }
        plans {
          ...VLMonetizationPlan
        }
        layout {
          ...PartialFonts
          ...Layout
        }
      }

      ...on LinearchannelStandaloneModule{
        id
        metadataMap
          contentData{
          id
          ...PartialGist
       		...on Linearchannel{
            publishDate
            plans {
              type
              planIds
              planGroupIds
            }
            channels{
              id
              thumbnail
              title
              epgInfo{
                vlUrl
              } 
        
            }
          }
        }
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ...on LinearchannelDetailModule{
        id
        metadataMap
        contentData{
          id
          ...PartialGist
       		...on Linearchannel{
            plans {
              type
              planIds
              planGroupIds
            }
            channels{
              id
              title
              thumbnail
              epgInfo{
                vlUrl
              } 
            }
          }
        }
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ...on StandingsModule{
        metadataMap
        layout {
         ...Layout
         ...PartialFonts
       }
     }
     ...on LeaderboardModule{
       metadataMap
       layout {
        ...Layout
        ...PartialFonts
      }
    }
     ...on TeamChampionshipModule{
      metadataMap
      contentData {
        id
        title
        gist {
          id
          title
          description
          imageGist {
            r1x1
            r16x9
            r16x9
          }
        }
        ...on Game{
          championsData{
            id
          }
          golfStats {
            currentRound
            currentStatusIdentifier
            eventStatus
            roundStates {
              round
              statusIdentifier
            }
          }
        }
      }
      setting {
        hideDate
        hideTitle
        lazyLoad
        seeAll
        seeAllCard
        showMore
        seeAllPermalink
        showMoreCta
      }
      layout {
       ...Layout
       ...PartialFonts
       }
     }
     ...on LeaderboardModule{
     metadataMap
     contentData{
     ... on Game {
      ...PartialGameContent_1
       }
     } 
     layout {
      ...Layout
      ...PartialFonts
     }
    }
      ... on ArticleDetailModule {
        id
        title
        contentData {
          ... on Article {
            metadata {
              name
              value
            }
            publishDate
            updateDate
            articleAssets {
              url
            }
            readTime
            summaryText
            gist {
              id
              description
              title
              contentType
              permalink
              imageGist {
                r32x9
                r16x9
                r4x3
                r3x4
                r1x1
                r9x16
              }
            }
            imageList{
              id
              name
              url
            }
            author {
              name
            }
            badges{
              id
              title
              alignment
              type
              visible
              images{
                r4x3
                r3x4
                r1x1
                r32x9
                r16x9
                r9x16
              }
              style{
                backgroundColor
                gradientColor
                textColor
                borderColor
                borderWidth
              }
            }
          }
        }
        layout {
          ...PartialFonts
          ...Layout
        }
        metadataMap
      }

      ... on VideoPlaylistDetailModule {
        id
        contentData {
          id
          title
          gist {
            id
            contentType
            title
            permalink
            description
          }
          ... on VideoPlaylist {
            metadata{
              name
              value
            }
            videoList {
              gist {
                id
                title
                description
                permalink
                imageGist {
                  r32x9
                  r16x9
                  r4x3
                  r3x4
                  r1x1
                  r9x16
                }
              }
            }
            badges{
              id
              title
              alignment
              type
              visible
              images{
                r4x3
                r3x4
                r1x1
                r32x9
                r16x9
                r9x16
              }
              style{
                backgroundColor
                gradientColor
                textColor
                borderColor
                borderWidth
              }
            }
          }
        }
        layout {
          ...PartialFonts
          ...Layout
        }
        metadataMap
      }
      ... on StandaloneVideoPlayerModule {
        title
        subtitle
        contentData {
          id
          gist {
        scheduleStartDate
        scheduleEndDate
          }
          ...PartialGist
          ... on Video {
            ...PartialVideo_1
          }
        }
        metadataMap
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on CuratedTrayModule {
        title
        subtitle
        contentType
        contentData {
          id
          ...PartialGist
          ... on Video {
            publishDate
            ...PartialVideo_1
          }
          ... on All {
            publishDate
          }
          ... on Linearchannel {
            publishDate
          }
          ... on Page {
            ogDetails {
              thumbnailUrl
            }
          }
          ... on Series {
            publishDate
            monetizationBadgeIdentifier
            publishDate
            parentalRating
            seasonCount
            categories{
              id
              title
            }
            trailers{
              id
            }
            seasons {
              id
            }
            plans {
              type
              planIds
              planGroupIds
            }
            badges{
              id
              title
              alignment
              type
              visible
              images{
                r4x3
                r3x4
                r1x1
                r32x9
                r16x9
                r9x16
              }
              style{
                backgroundColor
                gradientColor
                textColor
                borderColor
                borderWidth
              }
            }
          }
          ... on Game {
            publishDate
            ...PartialGameContent_1
          }
          ... on Article {
            publishDate
            updateDate
            readTime
            gist {
              id
              description
            }
            author {
              name
            }
            badges{
              id
              title
              alignment
              type
              visible
              images{
                r4x3
                r3x4
                r1x1
                r32x9
                r16x9
                r9x16
              }
              style{
                backgroundColor
                gradientColor
                textColor
                borderColor
                borderWidth
              }
            }
          }
          ... on VideoPlaylist {
            publishDate
            videoList {
              id
            }
            badges{
              id
              title
              alignment
              type
              visible
              images{
                r4x3
                r3x4
                r1x1
                r32x9
                r16x9
                r9x16
              }
              style{
                backgroundColor
                gradientColor
                textColor
                borderColor
                borderWidth
              }
            }
          }
        }
        metadataMap
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on TveActivateModule {
        id
        title
        metadataMap
        layout {
          ...Layout
        }
      }

      ... on RedeemModule {
        id
        title
        metadataMap
        layout {
          ...Layout
        }
      }
      ... on TveModule {
        id
        title
        metadataMap
        layout {
          ...Layout
        }
      }
      ... on GeneratedTrayModule {
        title
        subtitle
        next
        verticalVideosOnly
        contentData {
          id
          ...PartialGist
          ... on Video {
            publishDate
            ...PartialVideo_1
          }
          ... on All {
            publishDate
          }
          ... on Linearchannel {
            publishDate
          }
          ... on Game {
            publishDate
            ...PartialGameContent_1
          }
          ... on Page {
            ogDetails {
              thumbnailUrl
            }
          }
          ... on Article {
            publishDate
            updateDate
            readTime
            author {
              name
            }
            badges{
              id
              title
              alignment
              type
              visible
              images{
                r4x3
                r3x4
                r1x1
                r32x9
                r16x9
                r9x16
              }
              style{
                backgroundColor
                gradientColor
                textColor
                borderColor
                borderWidth
              }
            }
          }
          ... on Series {
            publishDate
            trailers{
              id
            }
            plans{
              type
              planIds,
              planGroupIds
								
            }
            badges{
              id
              title
              alignment
              type
              visible
              images{
                r4x3
                r3x4
                r1x1
                r32x9
                r16x9
                r9x16
              }
              style{
                backgroundColor
                gradientColor
                textColor
                borderColor
                borderWidth
              }
            }
          }
        }
        metadataMap
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on RecommendationModule {
        id
        title
        moduleType
        contentType
        verticalVideosOnly
        setting {
          hideDate
          hideTitle
          lazyLoad
          seeAll
          seeAllCard
          showMore
          seeAllPermalink
          showMoreCta
        }
        metadataMap
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on SubscriptionModule {
        metadataMap
        layout {
          ...Layout
        }
      }
      ... on AuthenticationModule {
        metadataMap
        layout {
          ...Layout
          fontSetting {
            title {
              fontFamilyName
              fontSize
              fontWeight
            }
            inputBoxPlaceholder {
              fontFamilyName
              fontSize
              fontWeight
            }
            loginCta {
              fontFamilyName
              fontSize
              fontWeight
            }
            description {
              fontFamilyName
              fontSize
              fontWeight
            }
          }
        }
      }
      ...on LibraryModule {
        id
        metadataMap
        moduleType
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on UserManagementModule {
        metadataMap
        rawText
        layout {
          ...Layout
          fontSetting {
            tab {
              fontFamilyName
              fontSize
              fontWeight
            }
            title {
              fontFamilyName
              fontSize
              fontWeight
            }
            subtitle {
              fontFamilyName
              fontSize
              fontWeight
            }
            button {
              fontFamilyName
              fontSize
              fontWeight
            }
            teamName {
              fontFamilyName
              fontSize
              fontWeight
            }
            playerName {
              fontFamilyName
              fontSize
              fontWeight
            }
            badge{
              fontFamilyName
              fontSize
              fontWeight
            }
          }
        }
      }
      ... on VideoDetailModule {
        id
        moduleType
        metadataMap
        title
        contentData {
          id
          title
          creditBlocks{
            title
            credits{
              title
            }
          }
          gist {
            id
            contentType
            permalink
            primaryCategory {
              id
              title
            }
            title
            scheduleStartDate
            scheduleEndDate
            description
            imageGist {
              r16x9
            }
          }

          ...PartialVideo_1
          ...on Video {
            network
            originalObjectId
            parentalRating
            categories {
              id
              title
            }
            plans {
              type
              planIds
              planGroupIds
            }
            relatedVideos {
              id
              title
              metadata{
                name
                value
              }
              monetizationModels{
                id
                type
              }
              publishDate
              gist {
                id
                contentType
                permalink
                title
                description
                imageGist {
                  r16x9
                }
              }
              ...PartialVideo_1
            }
          }
        
        }
        metadataMap
        plans {
          ...VLMonetizationPlan
        }
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      ... on CollectionDetailModule {
        	id
        	title
        	subtitle
        	moduleType
        	metadataMap
        	layout{
            id
            settings
            styles
            view
            blockName
            ...PartialFonts_1
          }
        	contentData{
           ...on Collection{
  					...PartialCollectionContent_1
          }
          id
          title
          gist {
              id
              title
              description
            	permalink
          }
        }
      }
      ... on CategoryDetailModule {
        id
        title
        next
        contentData {
          id
          ...PartialGist
          ... on Video {
            publishDate
            ...PartialVideo_1
          }
          ... on All {
            publishDate
          }
          ... on Game {
            publishDate
          }
          ... on Series {
            publishDate
          }
        }
        layout {
          ...PartialFonts
          ...Layout
        }
        category {
          id
          title
          gist{
            imageGist{
							r4x3
              r3x4
              r1x1
              r32x9
              r16x9
              r9x16
            }
          }
          team {
            id
            title
          }
        }
      }
      ... on TagDetailModule {
        title
        contentData {
          id
          ...PartialGist
          ... on Video {
            publishDate
            ...PartialVideo_1
          }
          ... on Game {
            publishDate
          }
          ... on Series {
            publishDate
          }
        }
        layout {
          ...Layout
        }
      }
      
      ... on ViewPlanModule {
        description
        metadataMap
        layout {
          ...PartialFonts
          ...Layout
        }
      }
      
      ... on ScheduleModule {
        id
        title
        subtitle
        metadataMap
        contentData {
          id
          ...PartialGist
          ... on Game {
            ...PartialGameContent_1
          }
        }
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      ... on LocateModule {
        id
        title
        metadataMap
        layout {
          ...Layout
          ...PartialFonts
        }
      }
      ... on FooterModule {
        metadataMap
        layout {
          ...Layout
        }
      }
    }
  }
}
fragment PartialGist on Content {
  id
  gist {
    id
    title
    contentType
    permalink
    description
    primaryCategory {
      id
      title
      gist { 
         imageGist {
           r32x9
           r16x9
           r4x3
           r3x4
           r1x1
           r9x16
         }
       }
     }
    imageGist {
      r32x9
      r16x9
      r4x3
      r3x4
      r1x1
      r9x16
    }
  }
}
fragment PartialFonts on ModuleLayout {
  fontSetting {
    programTitle{
      fontFamilyName
      fontSize
      fontWeight
    }
    programDuration{
      fontFamilyName
      fontSize
      fontWeight
    }
    programDescription{
      fontFamilyName
      fontSize
      fontWeight
    }
    monetizationCtaHeading{
      fontFamilyName
      fontSize
      fontWeight
    }
    monetizationCtaSubTitle{
      fontFamilyName
      fontSize
      fontWeight
    }
    monetizationCtaPrice{
      fontFamilyName
      fontSize
      fontWeight
    }
    featureItem{
      fontFamilyName
      fontSize
      fontWeight
    }
    ctaHeading{
      fontFamilyName
      fontSize
      fontWeight
    }
    sectionHeading{
      fontFamilyName
      fontSize
      fontWeight
    }
    offerCodeBannerTitle{
      fontFamilyName
      fontSize
      fontWeight
    }
    offerCodeBannerCta{
      fontFamilyName
      fontSize
      fontWeight
    }
    offerCodeBannerAmount{
      fontFamilyName
      fontSize
      fontWeight
    }
    offerCodeBannerPlanOff{
      fontFamilyName
      fontSize
      fontWeight
    }
    offerCodeBannerPlanTitle{
      fontFamilyName
      fontSize
      fontWeight
    }
    offerCodeBannerDescription{
      fontFamilyName
      fontSize
      fontWeight
    }
    regularSeasonTitle{
      fontFamilyName
      fontSize
      fontWeight
    }
    previewTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
     previewDescription {
      fontFamilyName
      fontSize
      fontWeight
    }
    position{
      fontFamilyName
      fontSize
      fontWeight
    }
    pointsTitle{
      fontFamilyName
      fontSize
      fontWeight
    }
    plan{
      fontFamilyName
     fontSize
     fontWeight 
   }
   loginWallTitle{
     fontFamilyName
     fontSize
     fontWeight
   }
   loginButton{
     fontFamilyName
     fontSize
     fontWeight
   }
   continueButton{
     fontFamilyName
     fontSize
     fontWeight
   }
   emailWallTitle{
     fontFamilyName
     fontSize
     fontWeight
   }
   subscriptionWallTitle{
     fontFamilyName
     fontSize
     fontWeight
   }
    title {
      fontFamilyName
      fontSize
      fontWeight
    }
    trayItemTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    subtitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    team {
      fontFamilyName
      fontSize
      fontWeight
    }
    button {
      fontFamilyName
      fontSize
      fontWeight
    }
    articleTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    articleDescription {
      fontFamilyName
      fontSize
      fontWeight
    }
    tab {
      fontFamilyName
      fontSize
      fontWeight
    }
    widget {
      fontFamilyName
      fontSize
      fontWeight
    }
    videoTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    videoDescription {
      fontFamilyName
      fontSize
      fontWeight
    }
    searchSuggestionTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    searchSuggestionDate {
      fontFamilyName
      fontSize
      fontWeight
    }
    navigation {
      fontFamilyName
      fontSize
      fontWeight
    }
    signUpBannerTitleText{
      fontFamilyName
      fontSize
      fontWeight
    }
    signUpBannerSubTitleText{
      fontFamilyName
      fontSize
      fontWeight
    }
    scoreSummary {
      fontFamilyName
      fontSize
      fontWeight
    }
    individualPlayerScore {
      fontFamilyName
      fontSize
      fontWeight
    }
    position {
      fontFamilyName
      fontSize
      fontWeight
    }
    infoOverlayTitle {
      fontFamilyName
      fontSize
      fontWeight
    }

    popupHeading {
      fontFamilyName
      fontSize
      fontWeight
    }
    popupCtaTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    popupCtaSubtitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    popupPrice {
      fontFamilyName
      fontSize
      fontWeight
    }
    popupDetail {
      fontFamilyName
      fontSize
      fontWeight
  }
  timerTitle {
    fontFamilyName
    fontSize
    fontWeight
  }
  timerValue{
    fontFamilyName
    fontSize
    fontWeight
  }
  detailPageTitleInfo{
    fontFamilyName
    fontSize
    fontWeight
  }
  subscribeNowCta{
    fontFamilyName
    fontSize
    fontWeight
  }
  detailPageDescriptionInfo{
    fontFamilyName
    fontSize
    fontWeight
  }
  connectTvProviderCta{
    fontFamilyName
    fontSize
    fontWeight
  }
	detailPageCategoryInfo{
    fontFamilyName
    fontSize
    fontWeight
  }  
  logoutCta{
    fontFamilyName
    fontSize
    fontWeight
  }
  loginCta{
    fontFamilyName
    fontSize
    fontWeight
  }
  badge{
    fontFamilyName
    fontSize
    fontWeight
    }
    planFeatures {
      fontFamilyName
      fontSize
      fontWeight
    }
    comparePlansHeading {
      fontFamilyName
      fontSize
      fontWeight
    }
    planBoxTitle{
      fontFamilyName
      fontSize
      fontWeight
    }
    planBoxDescription {
      fontFamilyName
      fontSize
      fontWeight
    }
    planBoxAmount{
      fontFamilyName
      fontSize
      fontWeight
    }
    swipeToInfo{
      fontFamilyName
      fontSize
      fontWeight
    }
}
}
fragment PartialFonts_1 on ModuleLayout {
  fontSetting {
    title {
      fontFamilyName
      fontSize
      fontWeight
    }
    popupHeading {
      fontFamilyName
      fontSize
      fontWeight
    }
    popupCtaTitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    popupCtaSubtitle {
      fontFamilyName
      fontSize
      fontWeight
    }
    popupPrice {
      fontFamilyName
      fontSize
      fontWeight
    }
    popupDetail {
      fontFamilyName
      fontSize
      fontWeight
    }
    badge{
      fontFamilyName
      fontSize
      fontWeight
    }
  }
}
fragment PartialVideo_1 on Video {
  parentalRating
  publishDate
  runtime
  plans {
    planIds
    type
    planGroupIds
  }
  monetizationBadgeIdentifier
  isVerticalVideo
  monetizationModels {
    id
    type
  }
  metadata {
    name
    value
  }
  trailers{
    id
  }
  streamingInfo{
    isLiveStream
  }
  series{
    gist{
      id
			title
      permalink
    }
  }
  badges{
    id
    title
    alignment
    type
    visible
    images{
      r4x3
      r3x4
      r1x1
      r32x9
      r16x9
      r9x16
    }
    style{
      backgroundColor
      gradientColor
      textColor
      borderColor
      borderWidth
    }
  }
}
fragment PartialVideo_2 on Video {
  id
  title
  plans {
    planIds
    type
  }
  gist{
    imageGist{
      r16x9
    }
  }
  parentalRating
  runtime
  monetizationBadgeIdentifier
  trailers{
    id
  }
  badges{
    id
    title
    alignment
    type
    visible
    images{
      r4x3
      r3x4
      r1x1
      r32x9
      r16x9
      r9x16
    }
    style{
      backgroundColor
      gradientColor
      textColor
      borderColor
      borderWidth
    }
  }
}
fragment Layout on ModuleLayout {
  id
  settings
  styles
  view
  type
  blockName
  isMasthead
}
fragment VLMonetizationPlan on MonetizationPlan {
  id
  name
  description
  identifier
  monetizationModel
  planDetails {
    ...VLPlanDetails
  }
  planDisplayOrder
  renewable
  renewalCyclePeriodMultiplier
  renewalCycleType
  featureSetting {
    ...VLPlanFeatureSettings
  }
  metadata {
    name
    value
  }
}

fragment VLPlanDetails on PlansDetails {
  title
    description
    countryCode
    visible
    displayStrikeThroughPrice
    strikeThroughPrice
    hidePlanPrice
    isDefault
    isPurchaseEnabled
    purchaseAmount
    isRentEnabled
    numberOfAllowedStreams
    numberOfAllowedDevices
    recurringPaymentAmount
    recurringPaymentCurrencyCode
    redirectUrl
  	rentAmount
  	rentalPeriodUnit
    rentalPeriodValue
  featureDetails {
    ...VLPlanDetailFeature
  }
  supportedDevices
  channel_ids
  taxIncluded
}


fragment VLPlanDetailFeature on PlanDetailFeature {
  textToDisplay
  value
  valueType
}

fragment VLPlanFeatureSettings on PlanFeatureSettings {
  includingAds
  isBeamingAllowed
  isHdStreaming
  isDownloadAllowed
  numberOfAllowedDevices
  numberOfAllowedStreams
  contentConsumption
  isLoginRequired
}
fragment PartialGameContent_1 on Game {
  persons{
    id
    title
    firstName
    lastName
    gist{
      id
      imageGist{
        r1x1
      }
    }
    team{
      gist{
        imageGist{
          r1x1
        }
      }
    }
  }
  championsData{
    id
  }
  id
  monetizationBadgeIdentifier
  plans {
    planIds
    type
  }
  author {
    name
  }
  gist {
    id
    title
  }
  livestreams {
    id
    title
  }
  displayAttribute
  metadata {
    name
    value
  }
  ticketUrl
  league{
    id
    title
  }
  homeTeam {
    id
    title
    shortName
    currentSeason
    records {
      PST {
        win
        loss
        points
        overtimeLosses
      }
      REG{
        win
        loss
        points
        overtimeLosses
      }
      PRE{
        win
        loss
        points
        overtimeLosses
      }
      PIT{
        win
        loss
        points
        overtimeLosses
      }
    }
    gist {
      title
      description
      imageGist {
        r32x9
        r16x9
        r4x3
        r3x4
        r1x1
        r9x16
      }
    }
  }
  awayTeam {
    id
    title
    shortName
    currentSeason
    records {
      PST {
        win
        loss
        points
        overtimeLosses
      }
      REG{
        win
        loss
        points
        overtimeLosses
      }
      PRE{
        win
        loss
        points
        overtimeLosses
      }
      PIT{
        win
        loss
        points
        overtimeLosses
      }
    }
    gist {
      title
      description
      imageGist {
        r32x9
        r16x9
        r4x3
        r3x4
        r1x1
        r9x16
      }
    }
  }
  highlights {
    id
    title
  }
  webliveUrl
  currentState
  preview {
    id
  }
  states {
    live {
      startDateTime
    }
  }
  schedules {
    startDate
    endDate
    venue {
       id
      title
      gist {
        id
        site
        permalink
        title
        description
        imageGist {
          r32x9
          r16x9
          r4x3
          r3x4
          r1x1
          r9x16
        }
        primaryCategory {
          id
          title
        }
        contentType
        languageCode
        timezone
        scheduleStartDate
        scheduleEndDate
      }
    }
  }
  score {
    status
    type
    number
    homePoint
    awayPoint
    clock
  }
  golfStats {
    currentRound
    currentStatusIdentifier
    eventStatus
    roundStates {
      round
      statusIdentifier
    }
    holesMappingData{
      holeNumber,
      position
    }
  }
  broadcaster
  badges{
    id
    title
    alignment
    type
    visible
    images{
      r4x3
      r3x4
      r1x1
      r32x9
      r16x9
      r9x16
    }
    style{
      backgroundColor
      gradientColor
      textColor
      borderColor
      borderWidth
    }
  }
  sportsRadar{
    id
    seasonId
    widgetType
  }
}
fragment PartialGameContent_2 on Game {
  id
  livestreams {
    id
    title
  }
  plans {
    planIds
    type
  }
  monetizationBadgeIdentifier
  author {
    name
  }
  gist {
    id
    title
  }
  displayAttribute
  webliveUrl
  currentState
  preview {
    id
  }
  broadcaster
  badges{
    id
    title
    alignment
    type
    visible
    images{
      r4x3
      r3x4
      r1x1
      r32x9
      r16x9
      r9x16
    }
    style{
      backgroundColor
      gradientColor
      textColor
      borderColor
      borderWidth
    }
  }
}
fragment PartialCollectionContent_1 on Collection{
	gist{
    id
    title
    permalink
    contentType
    imageGist{
      r16x9
    }
    description
  }
  multiviews {
    id
    title
    gist {
      id
      title
      permalink
      contentType
      scheduleStartDate
      scheduleEndDate
    }
     ... on Game{
      id
    	title
    	livestreams{
      	id
        title
    	}
      persons {
        id
      }
      currentState
    }
    ...PartialGist
    ...PartialVideo_2
    ...PartialGameContent_2
  }
  golfStats{
    ...GolfEventStats
  }
}
fragment GolfEventStats on GolfStats {
  currentRound
  currentStatusIdentifier
  eventStatus
  roundStates {
    round
    statusIdentifier
  }
  holesMappingData {
    holeNumber
    position
    holePar
    holeYard
  }
  singularPayload {
    p1score
    p2score
    p3score
    p4score
    hole
    toPlay
    par
    p1fn
    p1sn
    p2fn
    p2sn
    p3fn
    p3sn
    p4fn
    p4sn
    p1shot
    p2shot
    p3shot
    p4shot
    t1logo
    t2logo
    t3logo
    t4logo
    t1divider
    t2divider
    t3divider
    t4divider
    lscore
    ltext
    t1code
    t2code
    t3code
    t4code
    p1id
    p2id
    p3id
    p4id
    p1photo
    p2photo
    p3photo
    p4photo
    iSlate
    title
    leaderVis
    toPlayVis
    t1Wordmark
    t1color {
      primaryColor
      secondaryColor
    }
    t2color {
       primaryColor
      secondaryColor
    }
    t3color {
       primaryColor
      secondaryColor
    }
    t4color {
       primaryColor
      secondaryColor
    }
    }
}`
export const minifiedPageQuery=generateMinifiedQuery(pageQuery);
export const pageQuerySHA = generateHash(minifiedPageQuery);